<template>
  <div class="row">
    <table class="table table-bordered table-stripped">
      <thead>
        <tr>
          <th class="text-center" style="width: 40%;">ตัวแทนจำหน่าย</th>
          <th class="text-center" style="width: 20%;">คลังอุปกรณ์เบียร์สด</th>
          <th class="text-center" style="width: 20%;">พื้นที่เก็บ (คลังหลักพร้อมขาย)</th>
          <th class="text-center" style="width: 20%;">พื้นที่เก็บ (คลังถังเบียร์สด)</th>
        </tr>
      </thead>
      <tr v-for="map in userSmlMappings" :key="map.agentCode">
        <td class="text-center pt-4">{{ map.mappingToAgentCode }} {{ map.mappingToAgentName }}</td>
        <td><input v-model="map.whCode" type="text" maxlength="50" class="form-control" placeholder="หากไม่ระบุจะใช้ DBS222" /></td>
        <td>
          <input v-model="map.location1Code" type="text" maxlength="50" class="form-control" placeholder="หากไม่ระบุจะใช้ LC100" />
        </td>
        <td>
          <input v-model="map.location2Code" type="text" maxlength="50" class="form-control" placeholder="หากไม่ระบุจะใช้ LC300" />
        </td>
      </tr>
      <tr v-if="userSmlMappings.length == 0">
        <td class="text-center" colspan="4">ไม่พบข้อมูลโปรไฟล์ประเภทตัวแทนจำหน่าย</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    selectedCompanyProfiles: {
      type: Array,
      default() {
        return [];
      },
    },
    userSmlMappings: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  watch: {
    agents() {
      let mappings = [];
      this.agents.forEach((agent) => {
        let existed = false;
        this.userSmlMappings.forEach((map) => {
          if (map.mappingToAgentCode == agent.agentCode) {
            existed = true;
            mappings.push(map);
          }
        });
        if (!existed) {
          mappings.push({
            mappingToAgentCode: agent.agentCode,
            mappingToAgentName: agent.agentName,
            whCode: null,
            location1Code: null,
            location2Code: null,
          });
        }
      });
      this.userSmlMappings = mappings;
      this.$emit("update:userSmlMappings", this.userSmlMappings);
    },
  },
  computed: {
    agents() {
      var profiles = this.selectedCompanyProfiles.map((o) => {
        return { companyProfileTypeCode: o.data.companyProfileTypeCode, agentCode: o.data.agentCode, agentName: o.data.agentName };
      });

      return profiles.filter(
        (e, i) => e.companyProfileTypeCode === "COMPANY_PROFILE_TYPE_AGENT" && profiles.findIndex((a) => a.agentCode === e.agentCode) === i
      );
    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/User/UserSmlMapping.vue